
import {mapGetters} from 'vuex'
import Map from '@/components/Map.vue'
import Carousel from '@/components/Carousel.vue'

export default {
  components: {
    'google-map': Map,
    Carousel
  },
  props: {
    salle: {
      type: Object, default: () => {
      }
    },
    followingSlug: {type: String, default: null},
    precedingSlug: {type: String, default: null}
  },
  data() {
    return {
      api_url: "https://www2.showroom-fashionweek.com/api", // process.env.NUXT_ENV_API_URL
      showMap: false,
      onHover: false,
      url: process.env.NUXT_ENV_LOCAL_URL + (this.$i18n.getLocaleCookie() === 'fr' ? '/fr' : '') + '/lieu/' + this.salle.slug.toLowerCase(),
      emailSubject: encodeURIComponent(
        `ShowRoom FashionWeek: ${
          this.$i18n.getLocaleCookie() === 'en'
            ? this.salle.denominationEEEn
            : this.salle.denominationEE
        }`
      ),
      equipementsOptions: [
        {
          value: 'Béton Ciré',
          label: this.$t('venue_search.waxed_concrete')
        },
        {
          value: 'Espace Extérieur (jardin, terrasse, balcon)',
          label: this.$t('venue_search.outside')
        },
        {
          value: 'Parquet',
          label: this.$t('venue_search.wooden_floor')
        },
        {
          value: 'Vitrine sur rue',
          label: this.$t('venue_search.street_shop')
        },
        {
          value: 'De plain-pied',
          label: this.$t('venue_search.single_storey')
        },
        {
          value: 'Coin Cuisine',
          label: this.$t('venue_search.kitchenette')
        },
        {
          value: 'Verrière',
          label: this.$t('venue_search.canopy')
        },
        {
          value: 'Hébergement sur place',
          label: this.$t('venue_search.accommodation')
        },
        {
          value: 'Air conditionné',
          label: this.$t('venue_search.ac')
        },
        {
          value: 'Alarme',
          label: this.$t('venue_search.alarm')
        },
        {
          value: 'Sonorisation',
          label: this.$t('venue_search.sono')
        },
        {
          value: 'Restauration intégrée',
          label: this.$t('venue_search.screenAndVideoprojector')
        },
        {
          value: 'Mobilier',
          label: this.$t('venue_search.furniture')
        },
        {
          value: 'Machine à café',
          label: this.$t('venue_search.coffeeMachine')
        },
        {
          value: 'Micro-onde',
          label: this.$t('venue_search.microwave')
        },
        {
          value: 'Tableau blanc',
          label: this.$t('venue_search.paperboard')
        },
        {
          value: 'Vidéo-projecteur',
          label: this.$t('venue_search.videoprojector')
        },
        {
          value: 'Système de visioconférence',
          label: this.$t('venue_search.videoconferencing')
        },
        {
          value: 'Accès handicapé',
          label: this.$t('venue_search.accesHandicape')
        },
        {
          value: "Lumière du jour",
          label: this.$t('venue_search.lightOfDay')
        },
        {
          value: "Terrasse / extérieur",
          label: this.$t('venue_search.terrace')
        },
        {
          value: "machine à café",
          label: this.$t('venue_search.coffeeMachine')
        },
        {
          value: "L’espace peut-être vidé",
          label: this.$t('venue_search.can_be_emptied')
        },

        {
          value: "micro-onde",
          label: this.$t('venue_search.microwave')
        },
      ],
      structuredData: { // from https://schema.org/Accommodation
        "@context": "https://schema.org",
        "@type": "Accommodation",
        "name": this.$i18n.getLocaleCookie() === 'en'
          ? this.salle.denominationEEEn
          : this.salle.denominationEE,
        "description": this.structuredDataDescription,
        "image": this.salle.documents.slice(0, 4).map(doc => process.env.NUXT_ENV_API_URL + '/static/webImages/webp/thumb_' + doc._id + '.webp'),
        "floorSize": this.salle.perficie,
        "amenityFeature": this.salle.equipements,
        "telephone": "+33 6 68 82 01 64",
        "address": {
          "@type": "PostalAddress",
          "areaServed": this.salle.quartier,
          "addressLocality": "Paris",
          "addressCountry": "France"
        },
        "url": this.encodedUrl
      }
    }
  },
  head() {
    return {
      title: `Showroom Fashion Week Paris - ${this.salle.denominationEE}`,
      meta: [
        {charset: 'utf-8'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {hid: 'og:title', name: 'og:title', content: this.salle.denominationEE},
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.structuredDataDescription
        },
        {hid: 'og:image', name: 'og:image', content: this.api_url + this.salle.documents[0].path},
        {hid: 'og:url', name: 'og:url', content: this.encodedUrl},
        {
          hid: 'description-fr',
          lang: 'fr',
          name: 'description',
          content: this.salle.description.replace(/<[^>]*>?/gm, '')
        },
        {
          hid: 'description-en',
          lang: 'en',
          name: 'description',
          content: this.salle.descriptionEn.replace(/<[^>]*>?/gm, '')
        }
      ],
      link: [{rel: 'icon', type: 'image/x-icon', href: '/favicon.ico'}],
      script: [{type: 'application/ld+json', json: this.structuredData}]
    }
  },
  computed: {
    ...mapGetters('salles', ['isFavorite', 'lastSalleFromLieuxList']),
    encodedUrl() {
      return encodeURIComponent(this.url)
    },
    emailBody() {
      return encodeURIComponent(`Lien vers le lieu: ${this.url}`)
    },
    structuredDataDescription() {
      let description = this.$i18n.getLocaleCookie() === 'en'
        ? this.salle.descriptionEn === '' || !this.salle.descriptionEn
          ? ''
          : this.salle.descriptionEn
        : this.salle.description;


      description = description.replace(/<[^>]*>?/gm, '')
      return description;
    },
    description() {
      let description = this.$i18n.getLocaleCookie() === 'en'
        ? this.salle.descriptionEn === '<p>null</p>' || !this.salle.descriptionEn
          ? ''
          : this.salle.descriptionEn
        : this.salle.description;

      description = description.replace(/&nbsp;/g, ' ')
      return description;
    },
    images() {
      const images = []
      for (const document of this.salle.documents) {
        images.push({
          big: this.api_url + '/static/webImages/webp/' + document._id + '.webp',
          thumb: this.api_url + '/static/webImages/webp/thumb_' + document._id + '.webp'
        })
      }
      return images
    },
    equipements() {
      const equipements = [];
      for (const equipement of this.salle.equipements) {
        equipements.push(this.equipementsOptions.find(e => equipement === e.value) ? this.equipementsOptions.find(e => equipement === e.value).label : equipement)
      }
      return equipements
    }
  },
  mounted() {
    // this.url = process.env.NUXT_ENV_LOCAL_URL + (this.$i18n.getLocaleCookie() === 'fr' ? '/fr' : '') + '/lieu/' + this.salle.slug
    window.addEventListener('keydown', this.handleKeyPressed)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPressed)
  },
  methods: {
    // handleKeyPressed(e) {
    //   if (e.keyCode === 37) {
    //     this.$refs.slider.$emit('slidePre')
    //   } else if (e.keyCode === 39) {
    //     this.$refs.slider.$emit('slideNext')
    //   }
    // },
    getFollowing() {
      return {
        name:
          this.$route.name.includes('lieufavori')
            ? 'lieufavori-salleSlug'
            : 'lieu-salleSlug',
        params: {salleSlug: this.followingSlug}
      }
    },
    getPreceding() {
      return {
        name:
          this.$route.name.includes('lieufavori')
            ? 'lieufavori-salleSlug'
            : 'lieu-salleSlug',
        params: {salleSlug: this.precedingSlug}
      }
    },
    goToLieux() {
      this.$store.dispatch('salles/setLastSeenSalle', this.salle.slug.toLowerCase());
      const route = {name: 'lieux'}
      if (this.lastSalleFromLieuxList !== null) {
        route.hash = `#${this.lastSalleFromLieuxList.slug}`
      }
      this.$router.push(this.localePath(route))
    },
    goVirtual() {
      window.open(this.salle.virtualRealityUrl)
    },
    goToDemand() {
      if (!this.isFavorite(this.salle._id)) {
        this.$store.dispatch('salles/addFavoriteSalle', this.salle)
      }
      this.$router.push(this.localePath({name: 'demand'}))
    },
    toggleFavorite() {
      if (
        this.$store.state.salles.favorites.find(
          (el) => el._id === this.salle._id
        )
      ) {
        try {
          this.$store.dispatch('salles/removeFavoriteSalle', this.salle._id)
        } catch (error) {
          console.error(error)
        }
      } else {
        try {
          this.$store.dispatch('salles/addFavoriteSalle', this.salle)
        } catch (error) {
          console.error(error)
        }
      }
    },
    print() {
      window.print()
    }
  }
}
